<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="clickable article-card" @click="goToArticle(article)">
                    <div
                        class="article-card-watermark"
                        :style="{ backgroundImage: `url('${getArticleImage()}')` }"
                    />
                    <v-img
                        :src="getArticleImage()"
                        class="article-card-image"
                        contain
                        position="center center"
                    />
                    <div class="article-card-caption custom-orange">
                        <v-card-title class="white--text article-card-title" v-text="article.title" />
                        <v-card-subtitle class="white--text article-card-subtitle pt-3"> {{ getDate() }} </v-card-subtitle>
                        <div v-if="bodyPreview" class="white--text article-card-body mb-5">
                            {{ bodyPreview }}
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    // import momentTimezone from 'moment-timezone'
    export default {
        props: {
            article: {
                type: Object,
                default: null
            }
        },
        computed: {
            bodyPreview() {
                const htmlBody = this.article && this.article.body ? this.article.body : ''
                const decodedBody = this.decodeHtmlEntities(htmlBody)
                const plainText = decodedBody
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/\u00a0/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim()

                if (!plainText) {
                    return ''
                }

                return plainText
            }
        },
        methods: {
            decodeHtmlEntities(value) {
                if (!value || typeof document === 'undefined') {
                    return value || ''
                }

                const textarea = document.createElement('textarea')
                textarea.innerHTML = value
                return textarea.value
            },
            getArticleImage() {
                if (this.article.image) {
                    return `${process.env.VUE_APP_GOOGLE_BUCKET_URL}${this.article.image.imageName}`
                } else {
                    return require('@/assets/main_logo.png')
                }
            },
            goToArticle(article) {
                this.$router.push({ name: 'Article', params: { id: article.id } })
            },
            getDate() {
                const date = new Date(this.article.articleDate)
                return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
            }
        }
    }
</script>

<style scoped>
.article-card,
.article-card * {
    text-transform: none !important;
}

.article-card {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #0f2740;
}

.article-card-watermark {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    opacity: 0.3;
    filter: blur(8px);
    transform: scale(1.06);
    z-index: 0;
    pointer-events: none;
}

.article-card-image {
    position: relative;
    z-index: 1;
    flex: 0 0 auto;
    height: 360px;
    max-height: 360px;
    width: 100%;
    background-color: transparent;
}

.article-card-caption {
    position: relative;
    z-index: 1;
    flex: 0 0 auto;
    padding: 6px 8px;
}

.article-card-title {
    text-align: justify;
    word-break: break-word;
    line-height: 1.3;
    padding: 4px 8px;
}

.article-card-subtitle {
    text-align: end;
    word-break: break-word;
    padding: 0 8px 4px;
}

.article-card-body {
    padding: 0 8px 8px;
    text-align: left;
    line-height: 1.35em;
    font-size: 0.95rem;
    max-height: 4.05em;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

@media only screen and (max-width: 600px) {
    .article-card-image {
        height: 260px;
        max-height: 260px;
    }
}
</style>
